import { Box, Typography } from "@mui/material";

export default function ModalBox({
  children,
  title,
}: {
  children: React.ReactNode;
  title: string;
}) {
  return (
    <Box
      sx={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: 800,
        maxHeight: "90vh",
        bgcolor: "background.paper",
        boxShadow: 24,
        p: 4,
        borderRadius: 2,
        overflow: "auto",
      }}
    >
      <Typography
        sx={{
          mb: 2,
        }}
        variant="h6"
        component="h2"
        gutterBottom
      >
        {title}
      </Typography>

      {children}
    </Box>
  );
}
